<template>
  <div id="app">
    <the-navigation />

    <router-view></router-view>
  </div>
</template>

<script>
import TheNavigation from "@/components/TheNavigation";

export default {
  name: "app",

  components: {
    TheNavigation
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  height: 100vh;
}
body {
  height: 100vh;
}
</style>
